module.exports = __webpack_public_path__ + "img/td_v2.8346f3d.png";